import { pathOr } from 'ramda';

import { IState } from '../store';

export const getNewbuildingId = (state: IState) => {
  return pathOr(null, ['offerData', 'newObject', 'id'], state);
};
